import React from "react"
import Button from "aldoo-ra/Button"
import useT from "../Storefront/hooks/useT"
import clientRedirect from "../Storefront/utils/clientRedirect"

function NotFoundPage() {
  const t = useT()
  return (
    <div className="relative min-h-[70vh] bg-paper transition-colors" data-testid="not-found">
      <div className="relative flex flex-col w-full min-h-[70vh] items-center justify-center gap-[50px] px-4 py-16">
        <div className="flex flex-col items-center gap-2" aria-hidden="true">
          <img src="/static/p-images/aldoo-small--150x150.webp" alt="" width={90} height={90} />
          <span className="text-[96px] md:text-[140px] font-black leading-none text-primary">404</span>
        </div>
        <h1 className="m-0 text-text text-center font-bold text-xl">{t`We couldn't find the page you're looking for`}</h1>
        <Button variant="primary_l" onClick={() => clientRedirect("/")}>
          {t`Back to Home`}
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage
